import { render, staticRenderFns } from "./ultrasonicReport.vue?vue&type=template&id=77a96920&scoped=true"
import script from "./ultrasonicReport.vue?vue&type=script&lang=js"
export * from "./ultrasonicReport.vue?vue&type=script&lang=js"
import style0 from "./ultrasonicReport.vue?vue&type=style&index=0&id=77a96920&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a96920",
  null
  
)

export default component.exports